import * as Yup from 'yup'

export const CreateTicketValidationSchema = Yup.object({
  ticket_title: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(150, 'Maximum 150 characters')
    .required('Ticket title is required'),
  ticket_description: Yup.string()
    .min(3, 'Minimum 3 characters')
    .max(1000, 'Maximum 1000 characters')
    .required('Ticket description is required'),
  assignee_uuid: Yup.string().required('Assignee is required'),
  ticket_end_job_type_uuid: Yup.string().required('Property is required'),
})

export const ticketDetailsValidationSchema = Yup.object({
  ticket_comment_text: Yup.string().max(1000, 'Maximum 1000 characters').optional(),
})
